var DEFAULT_PAGE_SIZE = 10;
export function paginate(items, currentPage, pageSize) {
    if (pageSize === void 0) { pageSize = DEFAULT_PAGE_SIZE; }
    return items.slice((currentPage - 1) * pageSize, currentPage * pageSize);
}
export function normalizePageIndex(currentIndex, pagesCount) {
    if (!currentIndex || currentIndex < 1 || currentIndex > pagesCount) {
        return 1;
    }
    return currentIndex;
}
export function getPagesCount(items, pageSize) {
    if (pageSize === void 0) { pageSize = DEFAULT_PAGE_SIZE; }
    return Math.ceil(items.length / pageSize);
}
